import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { createFormData } from '../helpers/createFormdata';
import { getApiErrorMessage, toApiError } from '../utils';

interface RequestUpdateAvatarAreaParams {
	propId: string;
	areaId: string;
	avatar: File;
}

export function useUpdateAvatarArea() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async ({ propId, areaId, avatar }: RequestUpdateAvatarAreaParams) => {
			try {
				const formData = createFormData({ file: avatar });
				return (
					await api.put(`/user/prop/${propId}/area/updateAvatar/${areaId}`, formData, {
						params: { forBinding },
					})
				).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar avatar da área');
			}
		},
		onSuccess: (_, variables) => {
			queryClient.invalidateQueries({ queryKey: ['areas'] });
			queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
		},
		onError: (error) => {
			console.error(
				'Erro ao atualizar avatar da área:',
				getApiErrorMessage(error, 'Erro ao atualizar avatar da área')
			);
		},
	});
}
